import { useQuery } from "react-query";
import getExternalAccounts from "../services/getExternalAccounts";

function useGetExternalAccounts(token: string) {
  return useQuery(["getExternalAccounts"], () => getExternalAccounts(token));
}

export default useGetExternalAccounts;
